import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    HarvestEventEntityId,
    HarvestEventsProps
} from 'services/harvestEvents/types';
import EntityPathNamesValue from 'components/EntityPathNamesValue';
import { makeSelectHarvestEventEntityId } from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    entityId?: HarvestEventEntityId;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventEntityPathNamesValueComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { entityId } = this.props;
        if (entityId) {
            return <EntityPathNamesValue entityId={entityId} />;
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityId: makeSelectHarvestEventEntityId()
});

export default connect(mapStateToProps)(
    HarvestEventEntityPathNamesValueComponent
);
